import * as types from './types';

const getFormValues = (payload, initialState) => {
  return {
    type: types.GET_PRICE,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/posting/STEP_PRICE/${payload.postingId}`,
      method: 'GET',
      initialState
    }
  };
};

const setPriceInfo = payload => {
  return {
    type: types.SET_PRICE_INFO,
    payload
  };
};

const setExpenses = payload => {
  return {
    type: types.SET_PRICE_INFO,
    payload
  };
};

const resetInfo = () => ({
  type: types.RESET_INFO
});

export { getFormValues, setPriceInfo, setExpenses, resetInfo };
